import { gql } from '@apollo/client';
export const DELETE_CONTENTS = gql`
  mutation deleteContents($content_idx_list: [String!]!) {
    deleteContents(content_idx_list: $content_idx_list)
  }
`;